<template>
  <svg :class="svgClass" v-bind="$attrs">
    <use :xlink:href="iconName" />
  </svg>
</template>
<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  iconClass: {
    type: String,
    required: true,
  },
  className: {
    type: String,
    default: "",
  },
});

const iconName = computed(() => `#icon-${props.iconClass}`);
const svgClass = computed(() =>
  props.className ? "svg-icon " + props.className : "svg-icon"
);
</script>
<style scoped>
.svg-icon {
  width: 2.4rem;
  height: 2.4rem;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
